import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Lock, ArrowLeft, Loader2 } from "lucide-react";
import { http, errMsg, TOKEN_KEY } from "../lib/api";
import { LogoMark } from "../components/site/Logo";

export default function AdminLogin() {
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await http.post("/auth/login", { password: pw });
      localStorage.setItem(TOKEN_KEY, data.token);
      navigate("/admin/dashboard");
    } catch (ex) {
      setErr(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="grid min-h-screen place-items-center bg-pearl px-5" data-testid="admin-login-page">
      <div className="hero-glow" />
      <form onSubmit={submit} className="relative w-full max-w-md rounded-[28px] border border-ink/10 bg-white p-8 shadow-[0_30px_80px_-40px_rgba(13,15,18,0.35)] sm:p-10">
        <LogoMark className="h-12 w-12" />
        <h1 className="mt-6 font-display text-3xl font-extrabold uppercase tracking-tight text-ink">Area riservata</h1>
        <p className="mt-2 text-sm text-slate-600">Inserisci la password per gestire le vetture.</p>
        <label className="mt-8 block font-mono text-[11px] uppercase tracking-[0.22em] text-slate-600" htmlFor="pw">Password</label>
        <div className="relative mt-2">
          <Lock className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
          <input id="pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} autoFocus required
            className="h-12 w-full rounded-full border border-ink/15 bg-pearl pl-11 pr-4 text-ink outline-none focus:border-champagne"
            data-testid="admin-login-password-input" />
        </div>
        {err && <p className="mt-3 text-sm text-red-600" data-testid="admin-login-error">{err}</p>}
        <button type="submit" disabled={busy} className="btn-ink mt-6 w-full justify-center" data-testid="admin-login-submit-button">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Entra"}
        </button>
        <Link to="/" className="mt-6 inline-flex items-center gap-2 text-sm text-slate-600 hover:text-ink" data-testid="admin-login-back">
          <ArrowLeft className="h-4 w-4" /> Torna al sito
        </Link>
      </form>
    </main>
  );
}
